var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('TheTopButton'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('TheFooter'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('TheLoading',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}]})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }